
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 450 390"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#ED2939","d":"M0 0h450v390H0z"}}),_c('path',{attrs:{"fill":"#FAE042","d":"M0 0h300v390H0z"}}),_c('path',{attrs:{"d":"M0 0h150v390H0z"}})])
          )
        }
      }
    